import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {
      setActiveTab: _ctx.setActiveTab,
      activeTab: _ctx.activeTab
    }),
    (_ctx.activeTab === 'netherlands')
      ? _renderSlot(_ctx.$slots, "tab-netherlands", { key: 0 })
      : (_ctx.activeTab === 'international')
        ? _renderSlot(_ctx.$slots, "tab-international", { key: 1 })
        : _createCommentVNode("", true)
  ]))
}